import React from "react";
// import '../styles-others.css'
import '../loader.css'
export default function LoadingScreen({ agentName, colour ,HealthMobileView}) {
  let classes = (HealthMobileView) ? 'miniview loader' : 'loader';
  return (
    <div class={classes}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
